import React from 'react';
import GroupComponent from './GroupComponent';

const TextGroup = (props) => {
  return (
    <GroupComponent 
      {...props} 
      groupType="text" 
      actionSummary={props.actionSummary} 
      groupID={props.groupID} 
      role="text" 
    />
  );
};

export default TextGroup;